import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8e2831', // Hämiksen punainen
    },
    secondary: {
      main: '#eecaca', // Vaaleanpunainen valkoinen
    },
    text: {
      primary: '#474647', // Paasikiven harmaa
    },
    background: {
      default: '#8e2831', // Taustaväri
      paper: '#ffffff', // Korttien taustaväri
    },
  },
  typography: {
    fontFamily: 'Open Sans Condensed, Open Sans, sans-serif',
  },
});

export default theme;
